/**
 * Related Products Section - Shows up to 4 manually selected related products
 */
import ProductGroupCard from '@/components/ProductGroupCard';

const RelatedProducts = ({ products }) => {
  // Don't render if no products
  if (!products?.length) {
    return null;
  }

  return (
    <section 
      className="mt-4 pt-4 border-t border-site-border"
      data-testid="related-products-section"
    >
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-lg font-mono uppercase tracking-wider text-content-primary">
          Shop Related Items
        </h2>
      </div>

      {/* Product Grid - Max 4 items in a row */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {products.slice(0, 4).map((product) => (
          <ProductGroupCard 
            key={product.id} 
            group={product}
          />
        ))}
      </div>
    </section>
  );
};

export default RelatedProducts;
